import { Injectable } from '@angular/core';

@Injectable()
export class DataService {

  private _id: number[] = [0];

  set id(id: number[]) {
    this._id = id;
  }

  get id(): number[] {
    const number = this._id;
    this._id = [0];
    return number;
  }
}
